var PCSPHP_TRANSLATIONS_IT = {
	lang: {
		'es': 'Spagnolo',
		'en': 'Inglese',
		'fr': 'Francese',
		'de': 'Tedesco',
		'it': 'Italiano',
		'pt': 'Portoghese',
	},
	langShort: {
		'es': 'ES',
		'en': 'EN',
		'fr': 'FR',
		'de': 'DE',
		'it': 'IT',
		'pt': 'PT',
	},
	titles: {
		error: 'Errore',
		success: 'Successo',
		created: 'Creato',
		edited: 'Modificato',
	},
	errors: {
		pass_not_match: 'Errore: le password devono coincidere.',
		unexpected_error: 'Si è verificato un errore imprevisto.',
		unexpected_error_try_later: 'Si è verificato un errore imprevisto, riprova più tardi.',
		name_is_required: 'Il nome è obbligatorio.',
		name_should_be_string: 'Il nome deve essere una stringa.',
		lastname_is_required: 'Il cognome è obbligatorio.',
		lastname_should_be_string: 'Il cognome deve essere una stringa.',
		email_is_required: "L'email è obbligatoria.",
		email_should_be_string: "L'email deve essere una stringa.",
		user_is_required: "Il nome utente è obbligatorio.",
		user_should_be_string: "Il nome utente deve essere una stringa.",
		password_is_required: "La password è obbligatoria.",
		password_should_be_string: "La password deve essere una stringa.",
	},
	semantic_calendar: {
		days: ['D', 'L', 'M', 'M', 'G', 'V', 'S'],
		months: ['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'],
		monthsShort: ['Gen', 'Feb', 'Mar', 'Apr', 'Mag', 'Giu', 'Lug', 'Ago', 'Set', 'Ott', 'Nov', 'Dic'],
		today: 'Oggi',
		now: 'Adesso',
		am: 'AM',
		pm: 'PM',
	},
	semantic_form: {
		text: {
			unspecifiedRule: 'Inserisci un valore valido',
			unspecifiedField: 'Questo campo'
		},
		prompt: {
			empty: '{name} deve avere un valore',
			checked: '{name} deve essere selezionato',
			email: '{name} deve essere un indirizzo email valido',
			url: '{name} deve essere un URL valido',
			regExp: '{name} non è nel formato corretto',
			integer: '{name} deve essere un numero intero',
			decimal: '{name} deve essere un numero decimale',
			number: '{name} deve essere un numero',
			is: '{name} deve essere \'{ruleValue}\'',
			isExactly: '{name} deve essere esattamente \'{ruleValue}\'',
			not: '{name} non può essere \'{ruleValue}\'',
			notExactly: '{name} non può essere esattamente \'{ruleValue}\'',
			contain: '{name} non può contenere \'{ruleValue}\'',
			containExactly: '{name} non può contenere esattamente \'{ruleValue}\'',
			doesntContain: '{name} deve contenere \'{ruleValue}\'',
			doesntContainExactly: '{name} deve contenere esattamente \'{ruleValue}\'',
			minLength: '{name} deve contenere almeno {ruleValue} caratteri',
			length: '{name} deve contenere almeno {ruleValue} caratteri',
			exactLength: '{name} deve contenere esattamente {ruleValue} caratteri',
			maxLength: '{name} non può contenere più di {ruleValue} caratteri',
			match: '{name} deve corrispondere al campo {ruleValue}',
			different: '{name} deve essere diverso dal campo {ruleValue}',
			creditCard: '{name} deve essere un numero di carta di credito valido',
			minCount: '{name} deve avere almeno {ruleValue} opzioni',
			exactCount: '{name} deve avere esattamente {ruleValue} opzioni',
			maxCount: '{name} deve avere {ruleValue} o meno opzioni'
		}
	},
	semantic_search: {
		error: {
			logging: "Errore nella registrazione del debug, uscita.",
			maxResults: "I risultati devono essere un array per utilizzare l'impostazione maxResults",
			method: "Il metodo chiamato non è definito.",
			noEndpoint: "Nessun endpoint di ricerca specificato",
			noNormalize: "L'opzione \"ignoreDiacritics\" sarà ignorata. Il browser non supporta String().normalize(). Considera l'uso di <https://cdn.jsdelivr.net/npm/unorm@1.4.1/lib/unorm.min.js> come polyfill.",
			noResults: "La tua ricerca non ha prodotto risultati",
			noResultsHeader: "Nessun risultato",
			noTemplate: "Nessun nome di template valido specificato.",
			oldSearchSyntax: "L'impostazione searchFullText è stata rinominata in fullTextSearch per coerenza, aggiorna la configurazione.",
			serverError: "Si è verificato un problema nella richiesta al server.",
			source: "Impossibile cercare. Nessuna fonte utilizzata e il modulo API semantic non è incluso.",
		},
	},
	datatables: {
		lang: {
			"decimal": "",
			"emptyTable": "Nessuna informazione disponibile",
			"info": "Visualizzazione da _START_ a _END_ di _TOTAL_ elementi",
			"infoEmpty": "Visualizzazione da 0 a 0 di 0 elementi",
			"infoFiltered": "(filtrato da _MAX_ elementi)",
			"infoPostFix": "",
			"thousands": ".",
			"lengthMenu": "Visualizza _MENU_ elementi",
			"loadingRecords": "Caricamento...",
			"processing": "Elaborazione...",
			"search": "",
			"searchPlaceholder": "Cerca...",
			"zeroRecords": "Nessuna corrispondenza trovata",
			"paginate": {
				"first": "Primo",
				"last": "Ultimo",
				"next": "Successivo",
				"previous": "Precedente"
			},
			"aria": {
				"sortAscending": ": attiva per ordinare la colonna in modo crescente",
				"sortDescending": ": attiva per ordinare la colonna in modo decrescente"
			}
		}
	},
	date: {
		days: ['Domenica', 'Lunedì', 'Martedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sabato'],
		daysLetter: ['D', 'L', 'M', 'M', 'G', 'V', 'S'],
		months: ['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'],
		monthsShort: ['Gen', 'Feb', 'Mar', 'Apr', 'Mag', 'Giu', 'Lug', 'Ago', 'Set', 'Ott', 'Nov', 'Dic'],
		today: 'Oggi',
		now: 'Adesso',
		am: 'AM',
		pm: 'PM',
	},
	messenger: {
		'Error': 'Errore',
		'Ha ocurrido un error desconocido.': 'Si è verificato un errore sconosciuto.',
		'¡Listo!': 'Pronto!',
	},
	loginForm: {
		'Error': 'Errore',
		'Ha ocurrido un error inesperado, intente más tarde.': 'Si è verificato un errore imprevisto, riprova più tardi.',
		'Si continua con problemas para ingresar, por favor utilice la ayuda.': 'Se continui ad avere problemi per accedere, ti preghiamo di utilizzare l\'aiuto.',
		'Por favor, verifique los datos de ingreso y vuelva a intentar.': 'Controlla i dati di accesso e riprova.',
		'Por favor, ingrese al siguiente enlace para desbloquear su usuario.': 'Si prega di accedere al seguente link per sbloccare il tuo utente.',
		'Se ha presentado un error al momento de ingresar, por favor intente nuevamente.': 'Si è verificato un errore durante l\'accesso, riprova per favore.',
		'CONTRASEÑA_INVÁLIDA': '<span class="mark">Non valida</span> <span class="text">password</span>',
		'USUARIO_BLOQUEADO': '<span class="text">Utente</span> <span class="mark">bloccato</span>',
		'USUARIO_INEXISTENTE': '<span class="text">L\'utente</span> <span class="mark">%r</span> <span class="text">non esiste</span>',
		'ERROR_AL_INGRESAR': 'Accesso fallito',
	},
	userProblems: {
		'Será solucionada muy pronto, por favor verifique su correo en las próximas horas. <br> El correo puede estar en "No deseado", por favor revise la carpeta de Spam. El remitente del correo es <strong>%r</strong>.': 'Sarà risolto molto presto, controlla la tua email nelle prossime ore. <br> L\'email potrebbe trovarsi nella cartella "Spam", controlla la cartella di spam. Il mittente dell\'email è <strong>%r</strong>.',
		'Ingrese el código enviado a su correo, el correo puede estar en "No deseado", por favor revise la carpeta de Spam. El remitente del correo es <strong>%r</strong>.': 'Inserisci il codice inviato alla tua email, l\'email potrebbe trovarsi nella cartella "Spam", controlla la cartella di spam. Il mittente dell\'email è <strong>%r</strong>.',
		'El correo ingresado no está asociado a ningún usuario, por favor ingrese otra cuenta de correo o puede crear una solicitud de soporte para asociar ese correo a su cuenta.': 'L\'email inserito non è associato a nessun utente, inserisci un altro indirizzo email o puoi creare una richiesta di supporto per associare quell\'email al tuo account.',
		'El código ingresado está errado, por favor vuelva a ingresar el código, solicite uno nuevo o cree una solicitud de soporte para informar del error.': 'Il codice inserito è errato, per favore reinserisci il codice, richiedi uno nuovo o crea una richiesta di supporto per segnalare l\'errore.',
		'Ingrese con su usuario y la nueva contraseña': 'Accedi con il tuo nome utente e la nuova password',
		'Las contraseñas no coinciden': 'Le password non corrispondono',
	},
	avatar: {
		'Confirmación': 'Conferma',
		'¿Seguro de guardar el avatar?': 'Sei sicuro di salvare l\'avatar?',
		'Cargando...': 'Caricamento...',
		'¿Seguro de guardar la foto de perfil?': 'Sei sicuro di salvare la foto del profilo?',
		'Sí': 'Sì',
		'No': 'No',
	},
	public: {
		'Ver más': 'Leggi di più',
	},
}
